import { FormItemProps } from "@app/components/forms/types/props";
import { BooleanInputSchema } from "@app/components/forms/types/schema";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  Switch,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import { useEffect } from "react";

export const FormSwitch = ({
  form,
  schema,
  ...rest
}: FormItemProps<BooleanInputSchema>) => {
  useEffect(() => {
    if (
      form.getValues(schema.id) === undefined ||
      form.getValues(schema.id) === ""
    ) {
      form.setValue(schema.id, false);
    }
  }, []);

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            "flex flex-row items-start justify-between space-x-2 space-y-1",
            schema.appearance?.className,
            schema.appearance?.border ? "rounded-md border p-3 shadow-sm" : "",
            schema.behavior?.hidden && "hidden",
          )}
        >
          <div className="space-y-0.5">
            <FormLabel>
              {typeof schema.label === "function"
                ? schema.label(form.getValues())
                : schema.label}
            </FormLabel>
            {schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
          <FormControl>
            <Switch
              className="p-0"
              checked={field.value}
              onCheckedChange={field.onChange}
              {...schema.behavior}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
